import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {AGENCY_SELECT} from '../constants/SalesChannels';
import {OPTION} from '../constants/TravelAgencyTypes';
import {payAtVendor} from '../constants/supportedProductCodes';

const PaymentHOC = (C) => {
  class PaymentCont extends Component {

    static show(props) {
      return props.order.payment && (!props.appearance.originalCreditAgency || props.order.salesChannel === AGENCY_SELECT)
        && !props.order.request && props.order.bookingPrice.rates && props.order.bookingPrice.rates.length > 0
        && props.order.type !== OPTION
        && !payAtVendor(props.order.productCode);
    }

    static validate(props) {
      // @todo cover it with tests.
      return props.validatorFactory().then(factory => factory.getPaymentValidator(props.order))
        .then(validator => validator(props.order.payment.paymentOptionSelected));
    }

    constructor(props) {
      super(props);
      this.validate = this.validate.bind(this);
    }

    validate(value) {
      return this.props.validatorFactory().then(factory => factory.getPaymentValidator(this.props.order))
        .then(validator => validator(value))
        .then(() => true,
          () => true);
    }

    /* eslint class-methods-use-this: ["error", { "exceptMethods": ["paymentOptionSupportsVoucher"] }] */
    paymentOptionSupportsVoucher(payment) {
      const { paymentOptions, paymentOptionSelected } = payment;
      return paymentOptions.some(option => option.creditCardExternalId === paymentOptionSelected && option.voucherEnabled === true);
    }

    render() {
      return !PaymentCont.show(this.props) ? null : (
        <C
          actions={this.props.actions}
          appearance={this.props.appearance}
          errors={this.props.errors}
          order={this.props.order}
          rental={this.props.rental}
          paymentOptionSupportsVoucher={this.paymentOptionSupportsVoucher}
          selectPaymentOption={this.props.actions.selectPaymentOption}
          selectPaymentType={this.props.actions.selectPaymentType}
          validate={this.validate}
        />
      );
    }
  }

  PaymentCont.PropTypes = {
    validatorFactory:PropTypes.object.isRequired,
    order:PropTypes.object.isRequired,
    rental:PropTypes.object.isRequired,
    errors:PropTypes.object.isRequired,
    actions:PropTypes.object.isRequired,
    appearance:PropTypes.object.isRequired,
  };

  return PaymentCont;
};

export default PaymentHOC;
